import type { IContactDetailsFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import type { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

import { CONTACT_PAIRS } from "./constants";
import type { Mutable } from "app/helpers/types";

export interface TranslatedOption {
    label: string;
    value: ContactDetail;
}

export default class FindContactDetailsFilter extends FilterPanelBaseFilter<
    IContactDetailsFilterDto,
    readonly ContactDetail[],
    ContactDetail[] | undefined
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IContactDetailsFilterDto, readonly ContactDetail[]>) {
        super(deps);
    }

    isValueEmpty(value: IContactDetailsFilterDto | undefined): boolean {
        if (!value) {
            return true;
        }
        return !CONTACT_PAIRS.some(([key]) => Boolean(value[key]));
    }

    fromApiValue(value?: IContactDetailsFilterDto): ContactDetail[] | undefined {
        if (!value) {
            return undefined;
        }

        return CONTACT_PAIRS.filter(([key]) => Boolean(value[key])).map(([, detail]) => detail);
    }

    toApiValue(value: ContactDetail[] | undefined): IContactDetailsFilterDto | undefined {
        if (!value) {
            return undefined;
        }

        return CONTACT_PAIRS.reduce<IContactDetailsFilterDto>((acc, [key, detail]) => {
            acc[key] = value.includes(detail) || undefined;

            return acc;
        }, {});
    }

    calculateValueDelta = (
        previousValue: ContactDetail[] | undefined,
        newValue: ContactDetail[] | undefined,
    ): FilterValueDelta<ContactDetail> => {
        return calculateArrayDelta(previousValue, newValue);
    };
}
